// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Color definitions for the app
 */

.LocationHeader {
  display: flex;
  align-items: center;
  background-color: #FFFFFF;
  box-sizing: border-box;
  border-bottom: 1px solid #E1E1E9;
  height: 150px;
}
.LocationHeader .header {
  display: flex;
  align-items: center;
  margin: 0 30px;
}
.LocationHeader .header .location-information {
  padding-left: 16px;
}
.LocationHeader .header .location-information .page-title {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 900;
  letter-spacing: 0.5px;
  padding-bottom: 16px;
}
.LocationHeader .header .location-information .company-name {
  font-family: "Lato", sans-serif;
  font-size: 14px;
  letter-spacing: 0.5px;
  font-weight: 900;
  padding-bottom: 5px;
}
.LocationHeader .header .location-information .address {
  font-family: "Lato", sans-serif;
  font-size: 11px;
  line-height: 1.2;
  letter-spacing: 0.7px;
}
.LocationHeader .test-location-status {
  position: relative;
  align-self: flex-start;
  margin-left: 8px;
  background: rgba(149, 154, 173, 0.16);
  color: #959AAD;
}
.LocationHeader .queue {
  position: relative;
  flex-grow: 1;
  display: flex;
  align-items: center;
  margin: 0 24px;
  user-select: none;
  overflow: hidden;
  pointer-events: none;
  z-index: 1300;
}
.LocationHeader .queue .queue-items {
  display: flex;
  align-items: center;
}
.LocationHeader .queue .queue-items .item {
  width: 316px;
  height: 160px;
}
.LocationHeader .queue .queue-items .item.curr-item {
  z-index: 2;
}
.LocationHeader .queue .queue-items .item .item-card {
  display: flex;
  align-items: center;
  margin-top: 10px;
  border: 1px solid #E1E1E9;
  border-radius: 4px;
  height: calc(100% - 20px);
}
.LocationHeader .queue .queue-items .item .item-card .card-info-container {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 176px;
  border-radius: 4px 0 0 4px;
  height: 100%;
}
.LocationHeader .queue .queue-items .item .item-card .card-info-container .card-info {
  margin: 0 20px;
  font-size: 12px;
  border-radius: 4px;
}
.LocationHeader .queue .queue-items .item .item-card .card-info-container .card-info .player-offline {
  text-align: center;
}
.LocationHeader .queue .queue-items .item .item-card .card-info-container .card-info .player-offline .offline-icon {
  color: #CF0838;
  font-size: 28px;
  margin-bottom: 5px;
}
.LocationHeader .queue .queue-items .item .item-card .card-info-container .card-info .player-offline .offline-text {
  color: #959AAD;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.5;
}
.LocationHeader .queue .queue-items .item .item-card .card-info-container .card-info .now-playing {
  display: flex;
  align-items: center;
  color: #959AAD;
  text-transform: uppercase;
}
.LocationHeader .queue .queue-items .item .item-card .card-info-container .card-info .now-playing .now-playing-icon {
  margin-right: 8px;
}
.LocationHeader .queue .queue-items .item .item-card .card-info-container .card-info .song-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 84px;
  letter-spacing: normal;
}
.LocationHeader .queue .queue-items .item .item-card .card-info-container .card-info .song-info .song-title {
  font-weight: 900;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.LocationHeader .queue .queue-items .item .item-card .card-info-container .card-info .song-info .song-artist {
  color: #383838;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.LocationHeader .queue .queue-items .item .item-card .card-info-container .card-info .program-container {
  display: flex;
  align-items: center;
  letter-spacing: normal;
}
.LocationHeader .queue .queue-items .item .item-card .card-info-container .card-info .program-container .program-icon {
  margin-right: 5px;
}
.LocationHeader .queue .queue-items .item .item-card .card-info-container .card-info .program-container .program-name {
  font-weight: 900;
}
.LocationHeader .queue .queue-items .item .item-card .card-image {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 140px;
  border-radius: 0 4px 4px 0;
  height: 100%;
}
.LocationHeader .queue .queue-items .item .item-card .card-image img {
  width: 128px;
  height: 128px;
  border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./src/vibeguide/src/sass/color.scss","webpack://./src/web/client/src/components/Locations/IndividualLocation/LocationHeader.scss"],"names":[],"mappings":"AAAA;;EAAA;;ACEA;EACE,aAAA;EACA,mBAAA;EACA,yBDiBM;EChBN,sBAAA;EACA,gCAAA;EACA,aAAA;AAuFF;AArFE;EACE,aAAA;EACA,mBAAA;EACA,cAAA;AAuFJ;AArFI;EACE,kBAAA;AAuFN;AArFM;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,oBAAA;AAuFR;AApFM;EACE,+BAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;AAsFR;AAnFM;EACE,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AAqFR;AAhFE;EACE,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,qCDeQ;ECdR,cDpCM;ACsHV;AA/EE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EAEA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;AAgFJ;AA9EI;EACE,aAAA;EACA,mBAAA;AAgFN;AA9EM;EACE,YAAA;EACA,aAAA;AAgFR;AA9EQ;EACE,UAAA;AAgFV;AA7EQ;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AA+EV;AA7EU;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,0BAAA;EACA,YAAA;AA+EZ;AA7EY;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AA+Ed;AA7Ec;EACE,kBAAA;AA+EhB;AA7EgB;EACE,cDnFV;ECoFU,eAAA;EACA,kBAAA;AA+ElB;AA5EgB;EACE,cD/FR;ECgGQ,eAAA;EACA,gBAAA;EACA,gBAAA;AA8ElB;AA1Ec;EACE,aAAA;EACA,mBAAA;EACA,cDzGN;EC0GM,yBAAA;AA4EhB;AA1EgB;EACE,iBAAA;AA4ElB;AAxEc;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,sBAAA;AA0EhB;AAxEgB;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA0ElB;AAvEgB;EACE,cDhIP;ECiIO,mBAAA;EACA,gBAAA;EACA,uBAAA;AAyElB;AArEc;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;AAuEhB;AArEgB;EACE,iBAAA;AAuElB;AApEgB;EACE,gBAAA;AAsElB;AAhEU;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,0BAAA;EACA,YAAA;AAkEZ;AAhEY;EACE,YAAA;EACA,aAAA;EACA,kBAAA;AAkEd","sourcesContent":["/**\n * Color definitions for the app\n */\n\n// Theme Colors\n$primary: #333F48;\n$secondary: #222732;\n$yellow: #FECF0C;\n$red: #E02D4F;\n$teal: #23CCC3;\n$orange: #F66733;\n$lightGray: #F6F6F6;\n$whiteSmoke: #E1E1E9;\n$manatee: #959AAD;\n$obsidian: #383838;\n\n// Status Colors\n$success: #00A474;\n$warning: #FFC107;\n$error: #CF0838;\n\n// Other Colors\n$white: #FFFFFF;\n$black: #000000;\n$gray: #757575;\n$darkGray: #A4A7B7;\n$mediumGray: #E0E0E0;\n$lighterGray: #E3E7F4;\n$lightSlateGray: #8A8FA3;\n$carrot: #FF892E;\n$lightSmoke: #F5F4F5;\n$graphBlue: #1570EF;\n$lightOrchid: #7F56D9;\n$rainboots: #3361E1;\n$royalBlue: #4085DE;\n$sushi: #95C653;\n\n// Component Colors\n$primaryButtonBackground: $yellow;\n$primaryButtonText: $primary;\n$secondaryButtonBackground: $primary;\n$secondaryButtonText: $white;\n$navigationText: #95A3AD;\n$scheduleMusic: #FCC7B3;\n$scheduleMessageBlock: $teal;\n$scheduleInterrupt: #1997A3;\n$scheduleLoop: $primary;\n\n// Variants: Theme Colors\n$primary16: rgba($primary, 0.16);\n$primary40: rgba($primary, 0.4);\n$primary50: rgba($primary, 0.5);\n$primary60: rgba($primary, 0.6);\n$secondary25: rgba($secondary, 0.25);\n$secondary50: rgba($secondary, 0.5);\n$secondary75: rgba($secondary, 0.75);\n$yellow16: rgba($yellow, 16%);\n$yellow25: rgba($yellow, 25%);\n$yellow75: rgba($yellow, 75%);\n$orange16: rgba($orange, 0.16);\n$orange32: rgba($orange, 0.32);\n$orange50: rgba($orange, 0.5);\n$orange75: rgba($orange, 0.75);\n$manatee16: rgba($manatee, 0.16);\n$manatee50: rgba($manatee, 0.5);\n\n// Variants: Status Colors\n$success10: rgba($success, 0.08);\n$success16: rgba($success, 0.16);\n$success75: rgba($success, 0.75);\n$warning50: rgba($warning, 0.5);\n$error10: rgba($error, 0.1);\n$error16: rgba($error, 0.16);\n$error20: rgba($error, 0.2);\n$error50: rgba($error, 0.5);\n$error75: rgba($error, 0.75);\n$error85: rgba($error, 0.85);\n\n// Variants: Other Colors\n$gray50: #F9FAFB;\n$gray200: #EAECF0;\n$gray300: #D0D5DD;\n$gray400: #98A2B3;\n$gray500: #667085;\n$gray700: #344054;\n$gray900: #101828;\n$carrot16: rgba($carrot, 0.16);\n$rainboots16: rgba($rainboots, 0.16);\n$royalBlue16: rgba($royalBlue, 0.16);\n\n// Box colors (for color picker)\n$boxRed: $red;\n$boxPink: #F57A7A;\n$boxOrange: $orange;\n$boxYellow: $yellow;\n$boxGreen: #95C653;\n$boxDarkGreen: #00A474;\n$boxBlue: #33ACE1;\n$boxDarkBlue: #3361E1;\n$boxPurple: #6D6DB5;\n$boxDarkPurple: #332A4B;\n\n:export {\n  // Theme Colors\n  primary: $primary;\n  secondary: $secondary;\n  yellow: $yellow;\n  red: $red;\n  teal: $teal;\n  orange: $orange;\n  lightGray: $lightGray;\n  whiteSmoke: $whiteSmoke;\n  manatee: $manatee;\n  obsidian: $obsidian;\n\n  // Status Colors\n  success: $success;\n  warning: $warning;\n  error: $error;\n\n  // Other Colors\n  white: $white;\n  black: $black;\n  gray: $gray;\n  darkGray: $darkGray;\n  mediumGray: $mediumGray;\n  lighterGray: $lighterGray;\n  lightSlateGray: $lightSlateGray;\n  carrot: $carrot;\n  lightSmoke: $lightSmoke;\n  graphBlue: $graphBlue;\n  lightOrchid: $lightOrchid;\n  rainboots: $rainboots;\n  royalBlue: $royalBlue;\n  sushi: $sushi;\n\n  // Component Colors\n  primaryButtonBackground: $primaryButtonBackground;\n  primaryButtonText: $primaryButtonText;\n  secondaryButtonBackground: $secondaryButtonBackground;\n  secondaryButtonText: $secondaryButtonText;\n  navigationText: $navigationText;\n  scheduleMusic: $scheduleMusic;\n  scheduleMessageBlock: $scheduleMessageBlock;\n  scheduleInterrupt: $scheduleInterrupt;\n  scheduleLoop: $scheduleLoop;\n  \n  // Variants: Theme Colors\n  primary16: $primary16;\n  primary40: $primary40;\n  primary50: $primary50;\n  primary60: $primary60;\n  secondary25: $secondary25;\n  secondary50: $secondary50;\n  secondary75: $secondary75;\n  yellow16: $yellow16;\n  yellow25: $yellow25;\n  yellow75: $yellow75;\n  orange16: $orange16;\n  orange32: $orange32;\n  orange50: $orange50;\n  orange75: $orange75;\n  manatee16: $manatee16;\n  manatee50: $manatee50;\n\n  // Variants: Status Colors\n  success10: $success10;\n  success16: $success16;\n  success75: $success75;\n  warning50: $warning50;\n  error10: $error10;\n  error16: $error16;\n  error20: $error20;\n  error50: $error50;\n  error75: $error75;\n  error85: $error85;\n\n  // Variants: Other Colors\n  gray50: $gray50;\n  gray200: $gray200;\n  gray300: $gray300;\n  gray400: $gray400;\n  gray500: $gray500;\n  gray700: $gray700;\n  gray900: $gray900;\n  carrot16: $carrot16;\n  rainboots16: $rainboots16;\n  royalBlue16: $royalBlue16;\n\n  // Box colors (for color picker)\n  boxRed: $boxRed;\n  boxPink: $boxPink;\n  boxOrange: $boxOrange;\n  boxYellow: $boxYellow;\n  boxGreen: $boxGreen;\n  boxDarkGreen: $boxDarkGreen;\n  boxBlue: $boxBlue;\n  boxDarkBlue: $boxDarkBlue;\n  boxPurple: $boxPurple;\n  boxDarkPurple: $boxDarkPurple;\n}\n","@use '~vibeguide/sass/color.scss' as color;\n\n.LocationHeader {\n  display: flex;\n  align-items: center;\n  background-color: color.$white;\n  box-sizing: border-box;\n  border-bottom: 1px solid color.$whiteSmoke;\n  height: 150px;\n\n  .header {\n    display: flex;\n    align-items: center;\n    margin: 0 30px;\n\n    .location-information {\n      padding-left: 16px;\n\n      .page-title {\n        display: flex;\n        align-items: center;\n        font-size: 20px;\n        font-weight: 900;\n        letter-spacing: 0.5px;\n        padding-bottom: 16px;\n      }\n\n      .company-name {\n        font-family: 'Lato', sans-serif;\n        font-size: 14px;\n        letter-spacing: 0.5px;\n        font-weight: 900;\n        padding-bottom: 5px;\n      }\n\n      .address {\n        font-family: 'Lato', sans-serif;\n        font-size: 11px;\n        line-height: 1.2;\n        letter-spacing: 0.7px;\n      }\n    }\n  }\n\n  .test-location-status {\n    position: relative;\n    align-self: flex-start;\n    margin-left: 8px;\n    background: color.$manatee16;\n    color: color.$manatee;\n  }\n\n  .queue {\n    position: relative;\n    flex-grow: 1;\n    display: flex;\n    align-items: center;\n    // justify-content: flex-end;\n    margin: 0 24px;\n    user-select: none;\n    overflow: hidden;\n    pointer-events: none;\n    z-index: 1300;\n\n    .queue-items {\n      display: flex;\n      align-items: center;\n\n      .item {\n        width: 316px;\n        height: 160px;\n\n        &.curr-item {\n          z-index: 2;\n        }\n\n        .item-card {\n          display: flex;\n          align-items: center;\n          margin-top: 10px;\n          border: 1px solid color.$whiteSmoke;\n          border-radius: 4px;\n          height: calc(100% - 20px);\n\n          .card-info-container {\n            flex-grow: 1;\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n            width: 176px;\n            border-radius: 4px 0 0 4px;\n            height: 100%;\n\n            .card-info {\n              margin: 0 20px;\n              font-size: 12px;\n              border-radius: 4px;\n\n              .player-offline {\n                text-align: center;\n\n                .offline-icon {\n                  color: color.$error;\n                  font-size: 28px;\n                  margin-bottom: 5px;\n                }\n\n                .offline-text {\n                  color: color.$manatee;\n                  font-size: 16px;\n                  font-weight: 700;\n                  line-height: 1.5;\n                }\n              }\n\n              .now-playing {\n                display: flex;\n                align-items: center;\n                color: color.$manatee;\n                text-transform: uppercase;\n\n                .now-playing-icon {\n                  margin-right: 8px;\n                }\n              }\n\n              .song-info {\n                display: flex;\n                flex-direction: column;\n                justify-content: center;\n                height: 84px;\n                letter-spacing: normal;\n\n                .song-title {\n                  font-weight: 900;\n                  margin-bottom: 5px;\n                  white-space: nowrap;\n                  overflow: hidden;\n                  text-overflow: ellipsis;\n                }\n\n                .song-artist {\n                  color: color.$obsidian;\n                  white-space: nowrap;\n                  overflow: hidden;\n                  text-overflow: ellipsis;\n                }\n              }\n\n              .program-container {\n                display: flex;\n                align-items: center;\n                letter-spacing: normal;\n\n                .program-icon {\n                  margin-right: 5px;\n                }\n\n                .program-name {\n                  font-weight: 900;\n                }\n              }\n            }\n          }\n\n          .card-image {\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n            width: 140px;\n            border-radius: 0 4px 4px 0;\n            height: 100%;\n\n            img {\n              width: 128px;\n              height: 128px;\n              border-radius: 4px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export var primary = `#333F48`;
export var secondary = `#222732`;
export var yellow = `#FECF0C`;
export var red = `#E02D4F`;
export var teal = `#23CCC3`;
export var orange = `#F66733`;
export var lightGray = `#F6F6F6`;
export var whiteSmoke = `#E1E1E9`;
export var manatee = `#959AAD`;
export var obsidian = `#383838`;
export var success = `#00A474`;
export var warning = `#FFC107`;
export var error = `#CF0838`;
export var white = `#FFFFFF`;
export var black = `#000000`;
export var gray = `#757575`;
export var darkGray = `#A4A7B7`;
export var mediumGray = `#E0E0E0`;
export var lighterGray = `#E3E7F4`;
export var lightSlateGray = `#8A8FA3`;
export var carrot = `#FF892E`;
export var lightSmoke = `#F5F4F5`;
export var graphBlue = `#1570EF`;
export var lightOrchid = `#7F56D9`;
export var rainboots = `#3361E1`;
export var royalBlue = `#4085DE`;
export var sushi = `#95C653`;
export var primaryButtonBackground = `#FECF0C`;
export var primaryButtonText = `#333F48`;
export var secondaryButtonBackground = `#333F48`;
export var secondaryButtonText = `#FFFFFF`;
export var navigationText = `#95A3AD`;
export var scheduleMusic = `#FCC7B3`;
export var scheduleMessageBlock = `#23CCC3`;
export var scheduleInterrupt = `#1997A3`;
export var scheduleLoop = `#333F48`;
export var primary16 = `rgba(51, 63, 72, 0.16)`;
export var primary40 = `rgba(51, 63, 72, 0.4)`;
export var primary50 = `rgba(51, 63, 72, 0.5)`;
export var primary60 = `rgba(51, 63, 72, 0.6)`;
export var secondary25 = `rgba(34, 39, 50, 0.25)`;
export var secondary50 = `rgba(34, 39, 50, 0.5)`;
export var secondary75 = `rgba(34, 39, 50, 0.75)`;
export var yellow16 = `rgba(254, 207, 12, 0.16)`;
export var yellow25 = `rgba(254, 207, 12, 0.25)`;
export var yellow75 = `rgba(254, 207, 12, 0.75)`;
export var orange16 = `rgba(246, 103, 51, 0.16)`;
export var orange32 = `rgba(246, 103, 51, 0.32)`;
export var orange50 = `rgba(246, 103, 51, 0.5)`;
export var orange75 = `rgba(246, 103, 51, 0.75)`;
export var manatee16 = `rgba(149, 154, 173, 0.16)`;
export var manatee50 = `rgba(149, 154, 173, 0.5)`;
export var success10 = `rgba(0, 164, 116, 0.08)`;
export var success16 = `rgba(0, 164, 116, 0.16)`;
export var success75 = `rgba(0, 164, 116, 0.75)`;
export var warning50 = `rgba(255, 193, 7, 0.5)`;
export var error10 = `rgba(207, 8, 56, 0.1)`;
export var error16 = `rgba(207, 8, 56, 0.16)`;
export var error20 = `rgba(207, 8, 56, 0.2)`;
export var error50 = `rgba(207, 8, 56, 0.5)`;
export var error75 = `rgba(207, 8, 56, 0.75)`;
export var error85 = `rgba(207, 8, 56, 0.85)`;
export var gray50 = `#F9FAFB`;
export var gray200 = `#EAECF0`;
export var gray300 = `#D0D5DD`;
export var gray400 = `#98A2B3`;
export var gray500 = `#667085`;
export var gray700 = `#344054`;
export var gray900 = `#101828`;
export var carrot16 = `rgba(255, 137, 46, 0.16)`;
export var rainboots16 = `rgba(51, 97, 225, 0.16)`;
export var royalBlue16 = `rgba(64, 133, 222, 0.16)`;
export var boxRed = `#E02D4F`;
export var boxPink = `#F57A7A`;
export var boxOrange = `#F66733`;
export var boxYellow = `#FECF0C`;
export var boxGreen = `#95C653`;
export var boxDarkGreen = `#00A474`;
export var boxBlue = `#33ACE1`;
export var boxDarkBlue = `#3361E1`;
export var boxPurple = `#6D6DB5`;
export var boxDarkPurple = `#332A4B`;
export default ___CSS_LOADER_EXPORT___;
